import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragHandles = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 6,
	viewBox: "0 0 14 6",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 5.29183V4.04183H13.25V5.29183H0.75ZM0.75 1.9585V0.708496H13.25V1.9585H0.75Z",
		fill: "black",
		fillOpacity: .25
	})
});
export default SvgDragHandles;
